import React, { useEffect, useRef, useState } from 'react';
import cometdLib from 'cometd';

import { CometdActions } from './cometD/cometD-action';
import { CometDProvider } from './cometD/cometdProvider';
import { fetchConfigDetailsFromClientHost, loadLocalUser, watchForChatSDKEvents } from "./Simplify360Chat/Services/HWIframeBridge";
import { s360ConfigService } from "./Simplify360Chat/Services/S360Config";
import Simplify360Chat from "./Simplify360Chat/Simplify360Chat";

import "./App.css";

function App() {
  const [cometdInstance] = useState(new cometdLib.CometD());
  const appRef = useRef();

  const [user, setUser] = useState(null);
  const [chatMaximized, setChatMaximized] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {

    localStorage.clear();
    loadLocalUser();
    s360ConfigService.loadClientConfigFromToken();
    sessionStorage.setItem("handshaken", "false");
    watchForChatSDKEvents({ setUser, setChatMaximized, setRefresh }, () => { });
    fetchConfigDetailsFromClientHost();
  }, []);


  const configureCometd = async () => {
    const channel = localStorage.getItem("clientChannel");
    let secureCometdToken = localStorage.getItem("cometdToken");
    let secureCometdUser = localStorage.getItem("cometdUser");
    console.log(localStorage.getItem("cometdToken"), localStorage.getItem("cometdUser"), secureCometdUser, secureCometdToken, "secureCometdToken")
    let additional = {
      ext: {
        "com.inrev.authn": {
          user: !!secureCometdUser && secureCometdUser !== 'undefined' ? secureCometdUser : "cometuser1",
          token: !!secureCometdToken && secureCometdToken !== 'undefined' ? secureCometdToken : "adfwew283292"
        }
      },
    };

    const host = s360ConfigService.config.host;
    let connectionURL = `https://${host}/bmcometd/cometd`;

    cometdInstance.websocketEnabled = true;
    cometdInstance.configure({
      url: connectionURL.trim(),
      maxNetworkDelay: 10000,       // Maximum network delay
      backoffIncrement: 1000,       // Exponential backoff increment
      maxBackoff: 60000,            // Maximum backoff time
    });

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem("handshaken") !== "true") {

        cometdInstance.handshake(additional, function (handshakeReply) {
          if (handshakeReply.successful) {
            sessionStorage.setItem("handshaken", "true");
            console.log("COMETD-LOG:HANDSHAKE SUCCESSFUL", additional);
            const { subscribe } = CometdActions(cometdInstance);
            subscribe(channel, appRef); // client channel recieved from login
            resolve("COMETD-LOG:HANDSHAKE SUCCESSFUL");
          } else {
            console.error("COMETD-LOG:HANDHSAKE FAILED");
            reject("COMETD-LOG:HANDHSAKE FAILED");
          }
        })
      } else {
        const { subscribe } = CometdActions(cometdInstance);
        subscribe(channel, appRef);
        resolve("COMETD-LOG:HANDSHAKE SUCCESSFUL");
      }
    })
  }

  //STEP 9 HERE BY NOW WE GOT CONFIG IN S360CONFIGSERVICE.JS FROM WHERE WE CAN ACCESS CONFIG FROM ALL REACT COMPONENTS
  return (
    <CometDProvider cometdInstance={cometdInstance}>
      <div ref={appRef} id="App">
        {s360ConfigService.isConfigured() && (
          <Simplify360Chat
            user={user}
            chatMaximized={chatMaximized}
            refresh={refresh}
            configureCometd={configureCometd}
            appRef={appRef}
          />
        )}
      </div>
    </CometDProvider>
  );
}

export default App;
